<div class="kal-input-file">
    <input #fileUpload
           type="file"
           [id]="id + '_upload'"
           (change)="fileChange($event)"
           [accept]="allowedExtensions"
           style="display: none"/>
    <div (click)="fileUpload.click()">
        <ng-content></ng-content>
    </div>

    <ng-container *ngIf="!hideErrors">

        <p *ngIf="showFileSizeMessage"
           class="small"
           [ngClass]="{'gup-U-color--400': !hasFileError('filesize'), 'gup-U-color--red': hasFileError('filesize')}">
            {{ getErrorMessage('filesize') }}
        </p>

        <ng-container *ngFor="let error of messagesErrors">

            <p *ngIf="hasFileError(error.controlError) && error.controlError !== 'filesize'"
               class="small gup-U-color--red"
               [class.gup-O-link]="canDisplayHiddenExtensions(error.controlError)"
               kalTooltip="{{ croppedExtensions }}">
                {{ getErrorMessage(error.controlError) }}
            </p>

        </ng-container>

    </ng-container>

</div>
